/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import * as Common from '../components/Common';

class MemberTypePop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      memberType: this.props.memberType,
      style: null,
      memberTypeList: [
        {type: '학부모'},
        {type: '성인'},
        {type: '청소년'}
      ]
    };
  }

  componentDidMount() {
    this.setState({ style: Common.getCenterPosStyle(this.layer) });
  }

  _doChangeMemberTypeEvent = (e) => {
    this.setState({ memberType: e.target.dataset.membertype });
    var layerBgTimer = setTimeout(() => {
      this.layerBg.click();

      clearTimeout(layerBgTimer);
    }, 200);
  }

  render() {
    return (
      <div className="layer-pop" id="recog-pop" style={this.state.style} ref={ref => this.layer = ref}>	
	      <div className="bg" data-membertype={this.state.memberType} data-type="memberType" onClick={this.props.onClick} ref={ref => this.layerBg = ref}></div>
        <ul className="sel-list-pop">
          {this.state.memberTypeList.map((entity, index) => <li key={index} className={this.state.memberType === entity.type ? 'active' : ''}><a href={null} data-membertype={entity.type} onClick={this._doChangeMemberTypeEvent.bind(this)}>{entity.type}</a></li>)}
        </ul>
      </div>
    )
  }
}

export default MemberTypePop;